import { NgOptimizedImage } from '@angular/common';
import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { ShowleftDirective } from '../../../directives/animations/showleft.directive';

@Component({
  selector: 'section[app-home-fit-details]',
  imports: [NgOptimizedImage, MatIconModule, ShowleftDirective],
  templateUrl: './home-fit-details.html',
  styleUrl: './home-fit-details.scss',
})
export class HomeFitDetails {

}
